module.exports = __webpack_public_path__ + "static/img/27.fc70229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/27.png
// module id = nJoL
// module chunks = 0